import React from 'react';
import { roles } from '@nxsys/store/constants';

const ComingSoon = React.lazy(
  () => import('../../../modules/errorPages/ComingSoon'),
);

export const deductionsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/deductions',
    element: <ComingSoon />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/deductions/create',
    element: <ComingSoon />,
  },
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/deductions/:deductionId',
    element: <ComingSoon />,
  },
];
